import Vue from 'vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

Loading.props.loader.default = "bars"

Vue.component('loading', Loading)


// WEBPACK FOOTER //
// ./src/config/loading.js